import { Controller } from "@hotwired/stimulus"

// Tracks a sticky page-actions bar and toggles `.is-stuck` once the user has
// scrolled past its initial position. Pure UX polish — a subtle shadow appears
// so the bar separates from the content that scrolls underneath it.
export default class extends Controller {
  static values = {
    hasNavigation: Boolean
  }

  connect() {
    if (!this.hasNavigationValue || !this.navigationVisible()) {
      this.element.classList.remove("page-actions-bar--sticky-enabled", "is-stuck")
      return
    }

    this.sentinel = document.createElement("div")
    this.sentinel.className = "page-actions-bar__sentinel"
    this.sentinel.style.cssText = "position:absolute;top:0;left:0;height:1px;width:1px;pointer-events:none;"

    const parent = this.element.parentElement
    if (!parent) return

    // Insert sentinel right before the sticky bar so its visibility reflects
    // whether the bar has stuck to the viewport top.
    parent.insertBefore(this.sentinel, this.element)

    this.observer = new IntersectionObserver(([entry]) => {
      this.element.classList.toggle("is-stuck", !entry.isIntersecting)
    }, { threshold: [0], rootMargin: "0px 0px 0px 0px" })

    this.observer.observe(this.sentinel)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.sentinel && this.sentinel.parentNode) {
      this.sentinel.parentNode.removeChild(this.sentinel)
    }
  }

  navigationVisible() {
    const navContainer = this.element.querySelector(".page-actions")
    if (!navContainer) return false

    const interactiveNodes = navContainer.querySelectorAll("a, button, [role='button'], input[type='submit']")
    return Array.from(interactiveNodes).some((node) => this.isVisible(node))
  }

  isVisible(node) {
    const style = window.getComputedStyle(node)
    if (style.display === "none" || style.visibility === "hidden" || Number.parseFloat(style.opacity) === 0) {
      return false
    }

    return node.getClientRects().length > 0
  }
}
